import { useState, useEffect } from "react";
import { getSoldOutProducts } from "../api/soldOutApi";

export const useSoldOutProducts = () => {
  const [soldOutData, setSoldOutData] = useState({});
  const [isSoldOutApiLoading, setIsSoldOutApiLoading] = useState(true);

  useEffect(() => {
    getSoldOutProducts().then((data) => {
      if (Array.isArray(data) && data.length) {
        const soldOutProductData = data.reduce((acc, product) => {
          if (product.productOsr) {
            acc[product.productOsr] = product;
          }
          return acc;
        }, {});

        setSoldOutData(soldOutProductData);
      }
    }).finally(() => {
      setIsSoldOutApiLoading(false);
    });
  }, []);

  return { soldOutData, setSoldOutData, isSoldOutApiLoading };
};
